import { useTranslation } from "react-i18next";
import Tabs from "../../components/Tabs";

import GeneralStatistics from "../../features/statistics/CompanyStats/General";
import InTimeStatistics from "../../features/statistics/CompanyStats/InTime";
import RelationStatistics from "../../features/statistics/CompanyStats/Relation";

const CompanyStatistics = () => {
	const { t } = useTranslation();

	const tabs = [
		{
			label: t("general_statistics"),
			content: <GeneralStatistics />,
		},
		{
			label: t("in_time_statistics"),
			content: <InTimeStatistics />,
		},
		{
			label: t("margin_relation_statistics"),
			content: <RelationStatistics />,
		},
	];

	return <Tabs ariaLabel={t("company_statistics")} tabs={tabs} />;
};

export default CompanyStatistics;
